import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class UploadFlatFileDialogService {
    dialogCancel$: Subject<boolean> = new Subject<boolean>();
    dialogOpen$: Subject<any> = new Subject<any>();
}

@Injectable()
export class FlatFileActionService {
    // remove an item in flatfileActionComponent
    // removeItem$: Subject<string> = new Subject<string>();
    // update a cvs file in flatfileManagement page.
    updateItem$: Subject<any> = new Subject<any>();
}
